/** Build full PUT payload from current assignment + overrides so API receives all fields. */
export function buildFullTradeAssignmentPayload(assignment, overrides) {
    return {
        tradeType: assignment.tradeType,
        tradespersonId: overrides.tradespersonId ?? assignment.tradespersonId ?? undefined,
        tradespersonName: overrides.tradespersonName ?? assignment.tradespersonName ?? undefined,
        isEncumbered: overrides.isEncumbered ?? assignment.isEncumbered,
        duration: overrides.duration ?? assignment.duration ?? undefined,
        commencementDate: overrides.commencementDate ?? assignment.commencementDate ?? undefined,
        commencementTime: overrides.commencementTime ?? assignment.commencementTime ?? undefined,
        completionDate: overrides.completionDate ?? assignment.completionDate ?? undefined,
        completionTime: overrides.completionTime ?? assignment.completionTime ?? undefined,
        status: overrides.status ?? assignment.status,
        statusNote: overrides.statusNote ?? assignment.statusNote ?? undefined,
        didNotShow: overrides.didNotShow ?? assignment.didNotShow ?? null,
        reason: overrides.reason ?? assignment.reason ?? null,
        neatJob: overrides.neatJob ?? assignment.neatJob ?? null,
        reviewProductivity: overrides.reviewProductivity ??
            assignment.reviewProductivity ??
            undefined,
        reviewCleanlinessOfSiteArea: overrides.reviewCleanlinessOfSiteArea ??
            assignment.reviewCleanlinessOfSiteArea ??
            undefined,
        reviewQualityOfWorkmanship: overrides.reviewQualityOfWorkmanship ??
            assignment.reviewQualityOfWorkmanship ??
            undefined,
        reviewPunctuality: overrides.reviewPunctuality ?? assignment.reviewPunctuality ?? undefined,
        reviewPresentationAndBehaviour: overrides.reviewPresentationAndBehaviour ??
            assignment.reviewPresentationAndBehaviour ??
            undefined,
        reviewcompliance: overrides.reviewcompliance ?? assignment.reviewCompliance ?? undefined,
        termCondition: overrides.termCondition ?? assignment.termCondition ?? undefined,
    };
}
